const React = require('react');
const isNode = (typeof process !== 'undefined');
const Formsy = isNode ? require('formsy-react') : '<div/>';
const Select = isNode ? require('react-select') : <div/>;
const HOC = isNode ? Formsy.HOC : () => {};

class SelectComponent extends React.Component {
    render() {
        const isValid = this.props.isValid();
        const { onChange, name, options, className, placeholder} = this.props;
        const classNames = [].concat(!isValid && 'input-invalid', className).join(' ');
        return (
            <div className="forms__fieldContainer">
                <label className="form-label">{placeholder}</label>
                <Select
                    searchable={false}
                    clearable={false}
                    value={this.props.getValue()}
                    onChange={(option) => {
                        this.props.setValue(option);
                        onChange(option);
                    }}
                    name={name}
                    options={options}
                    className={classNames}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}
module.exports = HOC(SelectComponent);



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/FormComponents/Select/index.jsx